import React, { useState } from "react";
import { List, Paper } from "@material-ui/core";
import ItemList from "./ItemList";
import { SUGGESTIONS_NOT_FOUND } from "./constants";

const AutoSuggest = ({
  suggestionResults,
  onClick,
  searchQuery,
  selected,
  children,
}) => {
  if (suggestionResults?.results?.documents?.length === 0) {
    return (
      <Paper elevation={3}>
        <br></br><p>{SUGGESTIONS_NOT_FOUND}</p><br></br>
      </Paper>
    );
  }
  return (
    <List dense={true}>
      {suggestionResults?.results?.documents.map((suggestion, i) => {
        return (
          <ItemList
            item={i}
            selected={selected}
            key={suggestion["suggestion"]}
            suggestion={suggestion}
            searchQuery={searchQuery}
            onClick={onClick}
          >
            {children}
          </ItemList>
        );
      })}
    </List>
  );
};

export default AutoSuggest;
